module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Earth-33f151b31ddd0f291e2739469ea1f4b7.svg";